<template>
    <div class="case">
      <div class="case-main">
        <div class="case-content">
          <div class="content">
            <div class="ql-editor" v-html="details.content"></div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
   import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'
 
  export default {
    components: {
    },
    data(){
      return{
        type:'',
        routeParams:{},
        details:{}
      }
    },
    methods:{
      getDetails(){
        this.$apis.baseData.selectInfo({id:'001'}).then(res=>{
          this.details=res.data
        })
      }
    },
    mounted(){
      //console.log(this.$route)
      // this.details={}
      // this.routeParams=this.$route.params
      // this.getDetails()
    },
    activated(){
      this.details={}
      this.routeParams=this.$route.query
      this.getDetails()
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .case{
    display: flex;
    flex-direction: column;
  }
  .case-main{
    display: flex;
    flex-direction: column;
    flex: 1;
    align-items: center;
    width: 100%;
    overflow: hidden;
  }
  .case-content{
    margin-top: 10px;
    width: $public-width;
    max-width: 100%;
    overflow-x: auto;
    .title{
      margin: 10px;
      font-size: 18px;
      font-weight: bold;
    }
    .back{
      cursor: pointer;
    }
    .type{
      color: $color-main-primary;
    }
  }
  .content{
    display: flex;
    flex-direction: column;
    align-items: center;
    .title{
      font-size: 20px;
      font-weight: bold;
      margin: 10px 0;
    }
  }
  .ql-editor{
    user-select:text;
    width: 100%;
    ::v-deep img{
      max-width: 100%;
    }
  }
  </style>
  